﻿import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["search"];
    }

    static get values() {
        return {
            url: String
        };
    }

    searchTargetConnected(target) {
        var url = this.urlValue;

        jQuery(target).typeahead({
            hint: true,
            highlight: true,
            minLength: 3
        }, {
            displayKey: 'name',
            valueKey: 'id',
            templates: {
                suggestion: function (data) {
                    // category.
                    if (data.type === 'c') {
                        // perk category.
                        if (data.t === 'p') {
                            return '<div><span class="material-symbols-outlined" data-icon="grid_view"></span>&nbsp;' + data.name + '<span class="badge text-secondary">' + data.h.toUpperCase() + '</span>' + '</div>';
                        }
                        // reward category.
                        else {
                            return '<div><span class="material-symbols-outlined" data-icon="grid_view"></span>&nbsp;' + data.name + '<span class="badge text-secondary">' + data.h.toUpperCase() + '</span>' + '</div>';
                        }
                        
                    }
                    // affiliate.
                    else if (data.t === "a") {
                        return '<div><span class="material-symbols-outlined text-primary" data-icon="local_mall"></span>&nbsp;' + data.name + '<span class="badge text-primary">' + data.h.toUpperCase() + '</span>' + '</div>';
                    }
                    // digital gift card.
                    else if (data.t === "ev" && data.pt === "c") {
                        return '<div><span class="material-symbols-outlined text-info" data-icon="redeem"></span>&nbsp;' + data.name + '<span class="badge text-info">' + data.h.toUpperCase() + '</span>' + '</div>';
                    }
                    // digital cinema voucher.
                    else if (data.t === "evc" && data.pt === "c") {
                        return '<div><span class="material-symbols-outlined text-info" data-icon="local_activity"></span>&nbsp;' + data.name + '<span class="badge text-info">' + data.h.toUpperCase() + '</span>' + '</div>';
                    }
                    // product.
                    else {
                        return '<div><span class="material-symbols-outlined text-success" data-icon="featured_seasonal_and_gifts"></span>&nbsp;' + data.name + '<span class="badge text-success">' + data.h.toUpperCase() + '</span>' + '</div>';
                    }
                }
                //header: function (data) {
                //    if (data.t === "a" || data.pt === "c") {
                //        return '<h3>Perks</h3>';
                //    }
                //    else {
                //        return '<h3>Rewards</h3>';
                //    }
                //}
            },
            limit: 20, source: function (query, syncResults, asyncResults) {
                fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ term: query })
                })
                    .then((response) => response.json())
                    .then((data) => {
                        asyncResults(data);
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    });
            }
        }).on("typeahead:selected typeahead:autocompleted", function (e, datum) {
            window.location.href = datum.url;
        });

    }
}